import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, Modal, Space } from 'antd';
import ReactDOM from "react-dom";
import  { useState } from 'react'
import ShareComponent from './ShareComponent';

export const ModalShare = ({showModal, setShowModal, titulo, url}) => {
    // const [isModalOpen, setIsModalOpen] = useState(false);
    // const showModal = () => {
    //   setIsModalOpen(true);
    // };
    const handleOk = () => {
      //setIsModalOpen(false);
      //setConfirmAction(true)
      setShowModal(false)
    };
    const handleCancel = () => {
      //setIsModalOpen(false);
      setShowModal(false)
      //setConfirmAction(false)
    };
    return ReactDOM.createPortal(
      <>
        <Modal title="Comparte esta Experiencia" open={showModal} onOk={handleOk} onCancel={handleCancel} >
        <ShareComponent url={url} title={titulo} />
        
      </Modal>
      </>,
      document.getElementById('modal')
    );
}
